<template lang="pug">

v-stepper(v-model='e6', vertical='' non-linear=true)
  v-stepper-step(:complete='e6 > 1', step='1' :editable='edit')
    | Información del usuario
    small Ingresa la información personal para el nuevo usuario
  v-stepper-content(step='1')
    v-card.mb-12#user-data
      template
        v-text-field(v-model='user.name' :error-messages='nameErrors' :counter='50' label='Nombre' required='' :rules="nameRules")
        v-text-field(v-model='user.lastName' :error-messages='nameErrors' :counter='50' label='Apellidos' required='' :rules="nameRules")
        v-text-field(v-model='user.email' type='email' :error-messages='emailErrors' label='E-mail' :counter='100' required='' :rules="emailRules")
        v-text-field(v-model='user.age' :counter='4' label='Edad' )
        v-select(v-model='user.gender' :items='gens' :error-messages='selectErrorsGenm' label='Género' required='')
        v-select(v-model='user.type' :items='usrs_types' label='Tipo de usuario' required='')
        v-switch(v-model='b_inst' :label='`Cuenta institucional`')

      template(v-if='user.type == "Profesor"')
        .groups-container
          | Asocia grupos al Profesor
          br
          br
          v-data-table.elevation-1(v-model='user.asoc_groups' :headers='groupsHeaders' :items='groups' item-key='id' show-select='')

    v-btn(@click='clear("user")') Limpiar
    v-btn(color='primary', @click='e6 = 2') Continuar
  v-stepper-step(:complete='e6 > 2', step='2' :editable='edit') Institución
  v-stepper-content(step='2')
    v-card.mb-12
      template#institute-data
        small Verifique que el instituto que esta por agregar no exista
        v-combobox(v-model='user.institute.name' :items='institutes' label='Instituto' :error-messages='institutesError'  required='' :cleareable='clearInst' :rules="nameRules")

    v-btn(color='primary', @click='e6 = 3') Continuar
  v-stepper-step(:complete='e6 > 3', step='3' :editable='edit') Información adicional
  v-stepper-content(step='3')
    v-card.mb-12
      v-card.mb-12
      template#institute-data
        small ¿Has tomado cursos de inglés en los dos años anteriores? Sí es así, ¿Cuales?
        v-combobox(v-model='user.courses' multiple :items='courses' label='Instituto')

    v-btn(color='primary', @click='e6 = 4') Continuar
  v-stepper-step(:complete='e6 > 4', step='4' :editable='edit') Asocia el usuario a un instituto (Opcional)
  v-stepper-content(step='4')
    v-card.mb-12
      v-card.mb-12
      template#institute-data
        small Cuenta institucional asociada
        v-autocomplete(v-model='user_inst' :items='user_institutes' :loading='isLoading' :search-input.sync='search'
          hide-no-data='' hide-selected='' item-text='name' item-value='id' label='Usuarios de Institutos' 
          placeholder='Escribe para buscar la cuenta asociada' prepend-icon='mdi-database-search' return-object='')

    v-btn(color='primary', @click='e6 = 5') Continuar
  
  v-stepper-step(:complete='e6 > 5', step='5' :editable='edit') Asigna exámenes (Opcional)
  v-stepper-content(step='5')
    v-card.mb-12
      v-card.mb-12
      template#institute-data
        small Asigna exámenes al usuario
        v-data-table.elevation-1(v-model='selectedExams' :headers='examsHeaders' :items='exams' :single-select='singleSelect' item-key='id' show-select='')

    v-btn(color='primary', @click='e6 = 6') Continuar
  
  v-stepper-step(step='6') Verica que todos los Datos esten correctos
  v-stepper-content(step='6')
    v-card.mb-12
    v-btn(text='') Cancelar
    v-btn(color='success', @click='save()' :loading='loading') Registrar

    v-banner(v-model='msg_global' single-line='' transition='slide-y-transition')
    | {{ msg_global_txt }}
    template(v-slot:actions='{ dismiss }')
        v-btn(text='' color='primary'  @click="dismiss") Ok


</template>


<script>
  import { config } from '../config.js'

  export default {

    data () {
      return {
        e6: 1,
        clearInst: true,
        edit: true,
        b_inst: false,
        msg_global_txt:'',
        msg_global:false,
        loading: false,
        search: null,
        user_inst: '',
        user_institutes: [],
        groups: [],
        selectedGroups: [],
        groupsHeaders: [
          {
            text: 'Grupo',
            align: 'left',
            sortable: true,
            value: 'name'
          },
          { text: 'Descripción', value: 'desc', sortable: false },
          { text: 'Acciones', value: 'action', sortable: false }
        ],
        singleSelect: false,
        selectedExams: [],
        exams: [],
        usrs_types: ['Default', 'Profesor'],
        examsHeaders: [
          {
            text: 'Nombre del Examen',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          { text: 'Descripción', value: 'desc', sortable: false }
        ],
        isLoading: false,
        select:'',
        courses:['TOEFL', 'IELTS', 'Cambridge'],
        gens:['Masculino','Femenino'],
        institutes:[
          'ITESM',
          'UNAM',
          'IPN'
        ],
        user:{
          id: '',
          name:'',
          lastName:'',
          email:'',
          age:'',
          gender:'',
          type:'Default',
          courses: [],
          asoc_groups:[],
          institute: {
            name:''
          }
        },
        nameErrors: '',
        emailErrors: '',
        institutesError: '',
        selectErrorsGenm: '',
        nameRules: [
          v => !!v || 'Name is required',
          v => (v && v.length <= 100) || 'Name must be less than 100 characters',
        ],
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],

      }
    },
    mounted(){
      this.$emit("loadingEvent", true);
      this.initialize ();
    },
    watch:{
      search(){
        if (this.user_institutes.length > 0) return
        if (this.isLoading) return

        this.axios.get(`${config.serviceUri}users?inst=true`)
        .then( (response) => {
            console.log('Succes request: ',response.data);
            this.user_institutes = response.data.payload;
        })
        .catch( (error) => {
            console.log('Error: ', error);
            this.isLoading = false;
        });

      },
    },
    methods: 
    {
      initialize () {

        this.axios.get(`${config.serviceUri}exams`)
        .then( (response) => {
            console.log('Succes request: ',response.data);
            this.exams = response.data.payload;
            this.$emit("loadingEvent", false);
        })
        .catch( (error) => {
            console.log('Error: ', error);
            this.$emit("loadingEvent", false);
        });

        this.axios.get(`${config.serviceUri}catalogs?catalog=groups`)
        .then( (response) => {
            console.log('Succes request: ',response.data);
            this.groups = response.data.payload.sort(function (a, b) {
                            if (a.name > b.name) {
                              return 1;
                            }
                            if (a.name < b.name) {
                              return -1;
                            }
                            return 0;
                          });
            this.$emit("loadingEvent", false);
        })
        .catch( (error) => {
            console.log('Error: ', error);
            this.$emit("loadingEvent", false);
        });
      },
      clear(formV){
        switch(formV) {
          case 'user' : {
            this.user.name = '';
            this.user.email = '';
            this.user.age = '';
            break;
          }
        }
      },
      save(){
        this.$emit("loadingEvent", true);
        let _this = this;
        _this.loading = true;
        // userUpdate
        this.axios.post(`${config.serviceUri}users`, {
          id: _this.user.id,
          name: _this.user.email,
          id_relInst: _this.user_inst.id,
          type: _this.user.type,
          inst: _this.b_inst,
          asoc_groups: _this.user.asoc_groups,
          active: true
        })
        .then( (response) => {
            console.log('Succes User create: ', response.data);
            _this.user.id = response.data.payload.user.id;

            _this.axios.post(`${config.serviceUri}students?userid=${_this.user.id}`, {
              userId: _this.user.id,
              name: _this.user.name,
              lastName: _this.user.lastName,
              institute: _this.user.institute,
              gender: _this.user.gender,
              age:_this.user.age,
              courses: _this.user.courses,
              email: _this.user.email
            })
            .then( (response) => {
                console.log('Succes Student create: ',response.data);
                
                if( _this.selectedExams.length > 0){
                  let auth_exams = _this.selectedExams.map( e => e.id );
                  let new_auth = {
                    id_user: _this.user.id,
                    exams: auth_exams
                  }

                  this.axios.post(`${config.serviceUri}exams?assign=auth`, new_auth )
                    .then( (response) => {
                        console.log('Succes Realted Exam Created: ',response.data);
                        this.exams.push(response.data)
                        _this.msg_global = true;
                        _this.msg_global_txt = 'El usuario fue creado exitosamente'
                        _this.loading = false;
                        this.$emit("loadingEvent", false);
                    })
                    .catch( (error) => {
                        console.log('Error: ', error);
                        _this.loading = false;
                        _this.msg_global = true;
                        _this.msg_global_txt = 'Hubo un error al crear el usuario'
                        this.$emit("loadingEvent", false);
                    });
                }else{
                    _this.loading = false;
                    _this.msg_global = true;
                    _this.msg_global_txt = 'El usuario fue creado exitosamente'
                    this.$emit("loadingEvent", false);
                }          
            })
            .catch( (error) => {
                console.log('Error: ', error);
                _this.loading = false;
                _this.msg_global = true;
                _this.msg_global_txt = 'Hubo un error al crear el usuario'
                this.$emit("loadingEvent", false);
            });
            
        })
        .catch( (error) => {
            console.log('Error: ', error);
            _this.loading = false;
            _this.msg_global = true;
            _this.msg_global_txt = 'Hubo un error al crear el usuario'
            this.$emit("loadingEvent", false);
        });
      }
    }
  }
</script>

<style scoped>
  .v-card{
    box-shadow: none;
  }

  .v-btn{
    margin: 0 5px;
  }

  #user-data{
    display: flex;
    flex-wrap: wrap;
  }

  #user-data > .v-input{
    flex: 0 40%;
    width: 100%;
    margin: auto 5px;
  }

</style>

